<kendo-dialog-titlebar (close)="onCancel()">
    Apply to All
</kendo-dialog-titlebar>

@if(form){
<form [formGroup]="form">
    <div class="k-d-grid k-gap-y-lg">
        <p class="k-m-0">
            Mark the CPT code(s) that were addressed for all students during the session.
            <span style="color: var(--tb-kendo-color-error)">
                These selections will override any individual CPT code(s) previously entered for each student.
            </span>
        </p>

        <!-- <ng-container *ngFor="let cptCode of cptCodes; let i = index" [formGroupName]="i"> -->
        @for (item of groupCptCodes; track item.cptCode) {
        <kendo-formfield>
            <div class="k-mt-2">
                <input kendoCheckBox type="checkbox" [attr.aria-label]="item.cptCode + ' ' + item.cptCodeDescription" [formControlName]="item?.cptCodesMappingId" #chk />
                <kendo-label class="k-checkbox-label" [for]="chk">
                    <strong class="k-mr-4">{{ item.cptCode }}</strong>
                    {{ item.cptCodeDescription }}
                </kendo-label>
            </div>
        </kendo-formfield>
        }
        <!-- </ng-container> -->
    </div>
</form>
}

<kendo-dialog-actions>
    <button kendoButton themeColor="primary" (click)="onSave()">Save and Apply</button>
</kendo-dialog-actions>